'use client'

import { Image } from '@/components/v2/atoms/image/image'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const HeroCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 750px;
  place-content: center;
  background: white;
  padding: 54px 69px;
  height: 100%;

  ${down('xl')} {
    width: 100%;
    margin: 0 auto;
  }

  ${down('md')} {
    height: auto;
    padding: 30px;
  }
`

export const HeroCardHeader = styled.h1`
  font-family: DMSerifDisplay;
  color: #000000;
  font-size: 70px;
  font-weight: 400;
  line-height: 68px;
  margin-bottom: 15px;

  ${down('xl')} {
    font-size: 56px;
    line-height: 54px;
  }

  ${down('lg')} {
    font-size: 44px;
    line-height: 42px;
  }

  ${down('sm')} {
    font-size: 26px;
    line-height: 30px;
    margin-bottom: 10px;
  }
`

export const HeroCardText = styled.p`
  font-size: 16px;
  font-family: Oxygen;
  color: #000000;
  line-height: 24px;
  font-weight: 400;
  width: 500px;
  margin-bottom: 44px;

  ${down('xl')} {
    width: auto;
  }

  ${down('sm')} {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 60px;
  }
`

export const HeroCallToActionButtonWrapper = styled.div`
  font-size: 12px;
  font-family: Oxygen;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 179px;
  height: 48px;

  ${down('sm')} {
    width: auto;
  }
`

export const HeroPhotographerButtonWrapper = styled.div`
  font-size: 16px;
  font-family: Oxygen;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  a {
    text-decoration: underline;
  }
  ${down('sm')} {
    width: auto;
  }
`

export const HeroImageCamera = styled(Image)`
  width: auto;
  height: 24px;
  padding-right: 10px;
  position: relative;
  top: -2px;
`
